import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col-reverse lg:min-h-0 lg:flex-1 lg:flex-row" }

import { CardTitle } from '@/components/ui/card';
    import { computed, watch } from 'vue';
    import { createPayrollColumns } from '@/tables/columns/payroll';
    import { Head, router } from '@inertiajs/vue3';
    import { useI18n } from 'vue-i18n';
    import { usePage } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AddEmployeeToPayroll from '@/components/salary/AddEmployeeToPayroll.vue';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PageCard from '@/components/PageCard.vue';
    import PayrollApprovalAlertDialog from '@/components/salary/PayrollApprovalAlertDialog.vue';
    import PayrollFixedAddOnsAlertDialog from '@/components/salary/PayrollFixedAddOnsAlertDialog.vue';
    import PayrollGageAlertDialog from '@/components/salary/PayrollGageAlertDialog.vue';
    import PayrollLaunchArrangementMonthlyAlertDialog from '@/components/salary/PayrollLaunchArrangementMonthlyAlertDialog.vue';
    import PayrollSummary from '@/components/salary/PayrollSummary.vue';
    import PayrollUnlockAlertDialog from '@/components/salary/PayrollUnlockAlertDialog.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import RemoveEmployeeFromPayroll from '@/components/salary/RemoveEmployeeFromPayroll.vue';
    import type { SharedData, BreadcrumbItem, Payroll, PayrollDataField } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditPayroll',
  props: {
    payroll: {},
    editableFields: {},
    commentsExists: { type: Boolean },
    isApproved: { type: Boolean },
    clientCanUnlock: { type: Boolean },
    timeSinceApproval: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);
    const isClient = computed(() => !!page.props.auth.user.is_client);

    const { t } = useI18n();

    const { hasPermission } = usePermissions();

    const props = __props;

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'dashboards.payroll',
        },
        {
            title: 'payrolls.payroll_header',
            href: route('v2.salary.payrolls.index'),
        },
        {
            title: props.payroll.company.name,
            translated: true,
        },
    ];

    watch(selectedCompanyId, (newCompanyId, oldCompanyId) => {
        console.log(newCompanyId, oldCompanyId);
        if (newCompanyId !== oldCompanyId && oldCompanyId !== undefined) {
            router.visit(route('v2.salary.payrolls.index'));
        }
    });

    const { isPending, data } = useQuery({
        queryKey: [QueryKey.PAYROLL, selectedCompanyId, props.payroll.id],
        queryFn: getPayroll,
        placeholderData: [],
    });

    async function getPayroll() {
        const { data } = await axios.get(
            route('v2.salary.payroll.table', { payrollId: props.payroll.id }),
        );
        return data.data;
    }

    const columns = computed(() =>
        createPayrollColumns({
            editableFields: props.editableFields,
            payrollId: props.payroll.id,
            isApproved: props.isApproved,
        }),
    );

    const defaultColumnVisibility = computed(() => {
        return {
            id: false,
            comment: !props.isApproved || (props.isApproved && props.commentsExists),
        };
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _unref(t)('payrolls.edit.header', { company: props.payroll.company.name })
    }, null, 8, ["title"]),
    _createVNode(AppLayout, { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(PageCard, { class: "mt-0 flex min-h-96 min-w-0 flex-1 flex-col lg:mt-1.5 lg:mr-0" }, {
            default: _withCtx(() => [
              _createVNode(DataTable, {
                "table-key": _unref(QueryKey).PAYROLL,
                columns: columns.value,
                data: _unref(data),
                loading: _unref(isPending),
                "enable-search": false,
                "enable-filters": false,
                "default-column-visibility": defaultColumnVisibility.value,
                "default-sorting": [
                        {
                            id: 'name',
                            desc: false,
                        },
                    ]
              }, {
                title: _withCtx(() => [
                  _createVNode(_unref(CardTitle), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('payrolls.edit.header', { company: props.payroll.company.name })), 1)
                    ]),
                    _: 1
                  })
                ]),
                actions: _withCtx(() => [
                  _createVNode(DataTableToolbarActions, { name: "payroll" }, {
                    default: _withCtx(() => [
                      (_unref(hasPermission)(_unref(Permission).EMPLOYEES_CREATE))
                        ? (_openBlock(), _createBlock(AddEmployeeToPayroll, {
                            key: 0,
                            payroll: _ctx.payroll,
                            disabled: _ctx.isApproved
                          }, null, 8, ["payroll", "disabled"]))
                        : _createCommentVNode("", true),
                      (_unref(hasPermission)(_unref(Permission).EMPLOYEES_CREATE))
                        ? (_openBlock(), _createBlock(RemoveEmployeeFromPayroll, {
                            key: 1,
                            payroll: _ctx.payroll,
                            disabled: _ctx.isApproved,
                            employees: _unref(data)
                          }, null, 8, ["payroll", "disabled", "employees"]))
                        : _createCommentVNode("", true),
                      (
                                    _unref(hasPermission)(_unref(Permission).SALARY_PAYROLLS_UPDATE) && !_ctx.isApproved
                                )
                        ? (_openBlock(), _createBlock(PayrollApprovalAlertDialog, {
                            key: 2,
                            payroll: _ctx.payroll,
                            employees: _unref(data)
                          }, null, 8, ["payroll", "employees"]))
                        : _createCommentVNode("", true),
                      (
                                    _unref(hasPermission)(_unref(Permission).SALARY_PAYROLLS_UPDATE) &&
                                    _ctx.isApproved &&
                                    (_ctx.clientCanUnlock || !isClient.value)
                                )
                        ? (_openBlock(), _createBlock(PayrollUnlockAlertDialog, {
                            key: 3,
                            payroll: _ctx.payroll,
                            "time-since-approval": _ctx.timeSinceApproval,
                            "is-client": isClient.value
                          }, null, 8, ["payroll", "time-since-approval", "is-client"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["table-key", "columns", "data", "loading", "default-column-visibility"])
            ]),
            _: 1
          }),
          _createVNode(PayrollSummary, {
            payroll: _ctx.payroll,
            "is-approved": _ctx.isApproved
          }, null, 8, ["payroll", "is-approved"])
        ]),
        _createVNode(PayrollGageAlertDialog),
        _createVNode(PayrollLaunchArrangementMonthlyAlertDialog),
        _createVNode(PayrollFixedAddOnsAlertDialog)
      ]),
      _: 1
    })
  ], 64))
}
}

})